import { useEffect } from 'react';

export type CloudflareFlowFinishedProps = {
  onFinish?: () => void;
};

const CloudflareFlowFinished = ({ onFinish }: CloudflareFlowFinishedProps) => {
  useEffect(() => {
    onFinish?.();
  }, []);

  return null;
};

export default CloudflareFlowFinished;
